import React from "react";
import { Button } from 'antd';
import { useQuery } from "@apollo/client";
import { GET_EVENT } from 'graphql/query/event-gql';
import { PageWrapDefault } from "components/layout";
import { useActiveMenuItem } from "components/use-hooks";
import GraphicStorageRoute from 'components/routes/graphic-storage/graphic-storage-detail-route';
import GraphicStorage from 'components/graphic-storage';
import Events from 'components/events';
import { UploadFile, Localize } from "components/service";
import Icons from "components/icons";


const GraphicStorageDetailPage = ({ match, history }) => {

    useActiveMenuItem([ "graphic-storage-main" ], [ "graphic-storage" ]);

    const path = history.location.pathname.split('/').pop()
    const graphicStorageID = match ? parseInt(match.params.gsID) : null;

    const { data: { exhibitionEvent: graphicStorage } = {}, loading } = useQuery(GET_EVENT, {
        skip: !graphicStorageID,
        variables: {
            id: graphicStorageID
        },
        fetchPolicy: 'cache-and-network',
    });

    const {
        _setEventImportCollectionGraphic,
        loadingMutationEventImportCollectionGraphic
    } = Events.Hooks.importCollectionGraphic({ graphicStorageID });

    const pageNavbar = [
        // {
        //     label: Localize({ children: "NAVBAR_PAGES.Label_Overview" }).props.children,
        //     path: "overview"
        // },
        {
            label: Localize({ children: "NAVBAR_PAGES.Label_GraphicStorage" }).props.children,
            path: "graphics"
        },
        {
            label: Localize({ children: "NAVBAR_PAGES.Label_Stands" }).props.children,
            path: "stands"
        }
    ];

    const headerRightBar = graphicStorage && (
        <>
            <UploadFile
                varSetMutation={ { ee_id: graphicStorageID } }
                setMutation={ _setEventImportCollectionGraphic }
                loading={ loadingMutationEventImportCollectionGraphic }
                accept=".xlsx, .xls, .xml"
                uploadBtn={
                    <Button className='ant-btn-secondary'><Icons.Import /> <Localize>GLOBAL.Button_Text_ImportGraphicList</Localize></Button>
                } />
        </>
    );


    return (
        <PageWrapDefault
            className="page-graphic-storage-detail"
            loading={ loading }
            title={ path === 'create' ? <Localize>PAGES.Title_CreateGraphicStorage</Localize> : !loading && graphicStorage ? graphicStorage.title : 'Page 404' }
            dataExist={ path === 'create' ? true : !loading && graphicStorage }
            headerRightBar={ headerRightBar }
            pageNavbar={ graphicStorage ? pageNavbar : false }
            staticPath={ `${ GraphicStorage.Const.basePath }/${ graphicStorageID }` }
        >
            <GraphicStorageRoute
                graphicStorage={ graphicStorage }
                history={ history } />

        </PageWrapDefault>
    );
};

export default GraphicStorageDetailPage;
